import debounce from 'lodash/debounce';

const DEBOUNCE_DELAY_MILLS = 500;

export default (func: (...args: any) => any) => {
  return debounce(func, DEBOUNCE_DELAY_MILLS, {
    leading: true,
    trailing: false,
  });
};
